/**
 * Created by Sergio on 25.07.2017.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import dicts from './modules/dicts';
import booking from './modules/booking';

Vue.use(Vuex);

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    dicts,
    booking,
  },
});
